import { createSlice } from '@reduxjs/toolkit';

// const priceSlice = createSlice({
//   name: 'price',
//   initialState: {
//     value: 'oldvalue', // Initial state for priceState
//   },
//   reducers: {
//     setPrice: (state, action) => {
//       state.value = action.payload; // Update priceState
//     },
//   },
// });

// export const { setPrice } = priceSlice.actions; // Export the action to update price
// export default priceSlice.reducer; // Export the reducer

const priceSlice = createSlice({
  name: 'price',
  initialState: {
    value: 'oldvalue', // Default state as oldvalue
    price: null,       // Optional field for actual price if needed
  },
  reducers: {
    setPrice: (state, action) => {
      const { newPrice, priceType } = action.payload;
      
      // Update the state based on the provided price type
      state.value = priceType; // 'oldvalue' or 'newvalue'
      state.price = newPrice;  // The new price based on priceType
    },
  },
});

export const { setPrice } = priceSlice.actions; 
export default priceSlice.reducer;
